import { render } from "./PlayListVideoCard.vue?vue&type=template&id=72bde4bd"
import script from "./PlayListVideoCard.vue?vue&type=script&lang=js"
export * from "./PlayListVideoCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__